<template>
    <div>



        <CRow class="mb-2 mt-0 pt-0">
            <CCol md="12" class="mt-0 pt-0" >
                <b-button size="sm" v-if="issueMoreDetailShow" @click="issueMoreDetailShow = false">نمایش کمتر</b-button>
                <b-button size="sm"  v-if="!issueMoreDetailShow" @click="issueMoreDetailShow = true">نمایش بیشتر</b-button>



                <b-button size="sm"  variant="dark" data-toggle="modal"
                 :data-target="'#add-sprint'"> <i class="fas fa-plus"></i> Sprint </b-button>


                <router-link to="/sprint/list" class="btn btn-default btn-sm">مدیریت Sprint ها</router-link>




            </CCol>
        </CRow>

        <div style="width: 2000px;overflow-x: scroll">

            <div class="container-fluid">
                <div class="row flex-row flex-nowrap" >



                    <b-col style="max-width: 460px;background-color: #f1f1f1; border-radius: 4px;border: 1px solid #fff;box-shadow: 1px 4px 7px rgba(0,0,0,.4)" class="p-2 ml-2">

                        <CWidgetDropdown style="color: #222!important;"   header="Backlog" text="آماده به شروع ">
                            <template #default>
                                <CDropdown
                                        color=" p-0"
                                        placement="bottom-end"
                                        :caret="false"
                                >
                                    <template #toggler-content>
                                        <CIcon name="cil-task"/>
                                    </template>
                                    <CDropdownItem v-b-modal.modal-add-course variant="primary"
                                    >
                                        افزودن issue</CDropdownItem>
                                </CDropdown>
                            </template>

                        </CWidgetDropdown>


                        <table  class="table table-hover">

                            <draggable class="list-group" tag="ul" v-model="backlog.issues"  v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false" @change="issueMoved(backlog.id, backlog.title, null, null, $event)" >


                                <li  v-for="(issue, issueIndex) in backlog.issues" :key="issueIndex"
                                     style="width: 100%!important;border-top: 2px solid #9e9e9e;background-color: #fafafa;border-radius: 10px;
                                       overflow-x: hidden;margin-bottom: 15px;box-shadow: 0 0 3px rgba(0,0,0,.04)">

                                    <issueList  :issue="issue"  :issueMoreDetailShow="issueMoreDetailShow">
                                    </issueList>

                                </li>

                                <scroll-loader v-if="loadMore"  :loader-method="getMoreIssues" :loader-enable="loadMore">
                                </scroll-loader>

                            </draggable>

                        </table>

                    </b-col>





                    <b-col  v-for="(sprint, sprintsWithIssueIndex) in sprintsWithIssues" :key="sprintsWithIssueIndex"
                            style="background-color: #e2e2e2; border-radius: 4px;border: 1px solid #222;min-width: 200px;max-width: 500px;" class="p-2 mx-2">

                        <CWidgetDropdown  :style="{backgroundColor: styleColor(sprint.id)}"  :header="sprint.title" text="Sprint ">
                            <template #default>
                                <CDropdown
                                        color="transparent p-0"
                                        placement="bottom-end"
                                        :caret="false"
                                >
                                    <template #toggler-content>
                                        <CIcon name="cil-task"/>
                                    </template>
<!--                                    <CDropdownItem v-b-modal.modal-add-course variant="primary"-->
<!--                                    >-->
<!--                                        افزودن issue</CDropdownItem>-->

                                    <CDropdownItem variant="primary"
                                    >
                                        <b-button size="sm"  variant="warning" data-toggle="modal"
                                                  :data-target="'#edit-sprint-'+sprint.id"> <i class="fas fa-edit"></i> Sprint </b-button>
                                         </CDropdownItem>
                                </CDropdown>
                            </template>

                        </CWidgetDropdown>


                        <table  class="table table-hover">

                        <draggable class="list-group" tag="ul" v-model="sprint.issues"  v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false" @change="issueMoved(sprint.id, sprint.title, sprint.start_date, sprint.due_date, $event)" >


                            <li  v-for="(issue, issueIndex) in sprint.issues" :key="issueIndex"
                                 style="width: 100%!important;border-top: 2px solid #9e9e9e;background-color: #fafafa;border-radius: 6px;
                                       overflow-x: hidden;margin-bottom: 15px;box-shadow: 0 0 3px rgba(0,0,0,.04)">

                                <issueList  :issue="issue" :issueMoreDetailShow="issueMoreDetailShow">
                                </issueList>

                            </li>

                        </draggable>

                        </table>













                        <div :id="'edit-sprint-'+sprint.id" class="modal fade" role="dialog">
                            <div class="modal-dialog">

                                <!-- Modal content-->
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close"
                                                data-dismiss="modal">&times;</button>


                                        <div class="modal-title">
                                            افزودن Sprint
                                        </div>
                                    </div>
                                    <div class="modal-body">


                                        <div class="row text-right">


                                            <div class="col-12">
                                                <b-form-group  label="عنوان:" label-for="input-2"
                                                >
                                                    <b-form-input v-model="sprint.title" id="input-2" type="text">
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>

                                            <div class="col-12">
                                                <b-form-group   label="هدف/توضیحات:" label-for="input-2"
                                                >
                                                    <b-form-input v-model="sprint.note" id="input-2" type="text" >
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>

                                            <div class="col-6">
                                                <custom-time-picker  v-model="sprint.start_date"
                                                                     type="date" :clearable="true" placeholder="شروع Sprint" min="" max="">
                                                </custom-time-picker>
                                            </div>

                                            <div class="col-6">
                                                <custom-time-picker  v-model="sprint.due_date"
                                                                     type="date" :clearable="true" placeholder="پایان Sprint" min="" max="">
                                                </custom-time-picker>
                                            </div>


                                            <div class="col-12">
                                                <label>وضعیت:</label>
                                                <b-form-select v-model="sprint.state">
                                                    <b-form-select-option :value="1">فعال</b-form-select-option>
                                                    <b-form-select-option :value="0">غیر فعال</b-form-select-option>
                                                </b-form-select>
                                            </div>


                                        </div>

                                    </div>
                                    <div class="modal-footer">

                                        <button type="button" class="btn btn-success"
                                                @click="editSprint(sprint)" >ثبت</button>

                                        <button type="button" class="btn btn-default"
                                                data-dismiss="modal" >بستن</button>

                                    </div>
                                </div>

                            </div>
                        </div>




                    </b-col>











                </div>
            </div>



        </div>










        <b-modal id="modal-add-course" size="lg" title="افزودن پست " ok-only ok-variant="secondary" ok-title="Cancel">

            <addIssue  :parent_id="addIssue.parent_id"
                       :reply_id="addIssue.reply_id"
                       :section_id="addIssue.section_id">
            </addIssue>

        </b-modal>








        <div :id="'add-sprint'" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close"
                                data-dismiss="modal">&times;</button>


                        <div class="modal-title">
                            افزودن Sprint
                        </div>
                    </div>
                    <div class="modal-body">


                        <div class="row text-right">


                            <div class="col-12">
                                <b-form-group  label="عنوان:" label-for="input-2"
                                >
                                    <b-form-input v-model="newSprint.title" id="input-2" type="text">
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-12">
                                <b-form-group   label="هدف/توضیحات:" label-for="input-2"
                                >
                                    <b-form-input v-model="newSprint.note" id="input-2" type="text" >
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-6">
                                <custom-time-picker  v-model="newSprint.start_date"
                                                     type="date" :clearable="true" placeholder="شروع Sprint" min="" max="">
                                </custom-time-picker>
                            </div>

                            <div class="col-6">
                                <custom-time-picker  v-model="newSprint.due_date"
                                                     type="date" :clearable="true" placeholder="پایان Sprint" min="" max="">
                                </custom-time-picker>
                            </div>


                            <div class="col-12">
                                <label>وضعیت:</label>
                                <b-form-select v-model="newSprint.state">
                                    <b-form-select-option :value="1">فعال</b-form-select-option>
                                    <b-form-select-option :value="0">غیر فعال</b-form-select-option>
                                </b-form-select>
                            </div>


                        </div>

                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-success"
                                @click="createSprint()" >ثبت</button>

                        <button type="button" class="btn btn-default"
                                data-dismiss="modal" >بستن</button>

                    </div>
                </div>

            </div>
        </div>























    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import MainChartExample from './charts/MainChartExample'
    import WidgetsDropdown from './widgets/WidgetsDropdown'
    import WidgetsBrand from './widgets/WidgetsBrand'

    import { CChartLineSimple, CChartBarSimple } from './charts/index'

    import Multiselect from 'vue-multiselect'

    import draggable from "vuedraggable";
    import addIssue from './issue/add'
    import issueList from "./issue/list";


    export default {
        name: 'Dashboard',
        components: {
            MainChartExample,
            WidgetsDropdown,
            WidgetsBrand,
            CChartLineSimple,
            CChartBarSimple,

            Multiselect,

            draggable,

            addIssue,
            issueList,






        },
        data () {
            return {


                editable: true,
                isDragging: false,
                delayedDragging: false,




                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                loadMore: true,
                page: 0,
                pageSize: 10,
                voice: '',

                courseCategories:[],
                fileCategories:[],
                forumCategories:[],
                forums:[],


                issues:[],
                issues1:[],
                issues2:[],
                issueText: 0,
                newIssue: {
                    intro:'',
                    state:'0',
                    title:'',
                    text:'0',

                    voice:'',
                    file:'',
                    image:'',
                    video:'',

                    news:0,
                    course_id:null,
                    course_category_id:null,
                    forum_id:null,
                    forum_category_id:null,
                    fileLib_tags:null,
                    // issue_likes:null,
                    // userLike:null,

                    type:'ticket',
                    project_id:null,
                    board_id:2,
                    sprint_id:null,
                    users:[],

                    priority:2,
                    due_date:null,
                    tags:[],

                },

                rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

                showVoiceRecorder: false,
                showFileUploader: false,
                showImageUploader: false,
                showVideoUploader: false,

                src: null,
                srcPlay: null,

                issueAsCourse: false,
                issueAsForum: false,

                courseDisabled: false,
                forumDisabled: false,

                newComment:'',
                newReply:'',

                options:[],

                selectedTags: [],
                tags: [],
                isLoading: false,




                typeOptions: [
                    { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
                    { value: 'bug', text: 'ایراد (Bug)' },
                    { value: 'task', text: 'فعالیت (Task)' },
                    { value: 'user-story', text: 'لیست (User Story)' },
                    { value: 'epic', text: 'نسخه/فیچر (Epic)' },
                    { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
                    { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

                ],



                warningModal: false,


                sprintsWithIssues: [],
                steps: [],



                addIssue: {
                    parent_id: null,
                    reply_id: null,
                    sprint_id: null,
                    board_id: null,
                    process_id: null,
                    section_id: null,
                    step_id: null
                },

                backlog: {
                    id: 0,
                    title: 'backlog',
                    issues: []
                },


                issueMoreDetailShow:true,



                newSprint:{
                    title:'',
                    note:'',
                    duration:0,
                    start_date:'',
                    due_date:'',
                    state:1,

                },



            }
        },


        mounted() {

            // this.getSteps()
            this.getIssues()
            // this.getFileCategories()
            // this.getForumCategories()
            // this.getForums()
        },


        methods: {

            onMove({ relatedContext, draggedContext }) {
                const relatedElement = relatedContext.element;
                const draggedElement = draggedContext.element;
                if (this.isDragging==false)
                console.log('draggedContext', draggedContext,'relatedContext',relatedContext )
                return (
                    (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                );
            },

            issueMoved(sprintID, sprintTitle , sprintStart, sprintEnd, dragged){
                this.isDragging = false
                console.log(sprintID, sprintTitle ,'dragged', dragged)

                if(dragged.added){
                    console.log(sprintID, dragged.added.element)
                    this.updateIssue(dragged.added.element.id, dragged.added.element.title, dragged.added.element.state, sprintID, sprintStart, sprintEnd)
                }


            },

            updateIssue(id, title, state, sprintId, sprintStart, sprintEnd){
                var app = this;

                var params= {
                    // title: title,
                    // state: state,
                    sprint_id: sprintId,
                    start_date: sprintStart,
                    due_date: sprintEnd
                }

                axios.post(`/api/issue/edit/`+id,  params , app.auth)
                    .then(function (resp) {
                        console.log(resp,"")
                        // app.items.push(app.timing);
                        app.$snotify.success(' با موفقیت ویرایش شد');

                        app.getIssues()
                    })
                    .catch(
                        e => {
                            console.log(e);
                            app.$snotify.error('امکان ویرایش وجود ندارد');
                        }
                    );

            },

            color (value) {
                let $color
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },

            getIssues(){
                var app = this;
                axios.get('/api/intro/getSprintWithIssues', app.auth)
                    .then(function (response) {
                        app.sprintsWithIssues = response.data.data.data

                        console.log('sprintsWithIssues',response.data.data.data);
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            // getIssues(){
            //     var app = this;
            //     axios.get('/api/intro/index', app.auth)
            //         .then(function (response) {
            //             app.issues = response.data.data
            //             app.issues1 = response.data.data
            //             app.issues2 = response.data.data
            //             // console.log(response.data);
            //         })
            //         .catch(function (e) {
            //             console.log(e.response);
            //         });
            // },

            getMoreIssues(){
                var app = this;



                if(app.loadMore == true){

                    axios.get('/api/intro/backlog?page='+app.page, app.auth)
                        .then(res => {
                            // app.issues.concat(res.data.data)
                            res.data.data.forEach(
                                (val)=>{ app.backlog.issues.push(val)});

                            app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                            // Stop scroll-loader
                            res.data.data.length < app.pageSize && (app.loadMore = false)
                        })
                        .catch(error => {
                            console.log(error);
                        })

                }


            },

            getSteps(processID = null){
                var app = this;
                axios.get('/api/intro/steps/'+processID ,  app.auth)
                    .then(function (response) {
                        app.steps = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight
                const bottomOfPage = visible + scrollY >= pageHeight
                return bottomOfPage || pageHeight < visible
            },

            // onFileChangeImage(e) {
            //     this.newIssue.image = this.$refs.file.files[0];
            //     this.placeholder = this.$refs.file.files[0].name+'333'
            //     console.log(this.newIssue ,"test Issue image")
            // },
            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },

            //            openChat() {
            //                if (document.getElementById("box-chat").style.height == "400px") {
            //                    document.getElementById("box-chat").style.height = "60px"
            //                    document.getElementById("div-message-chat").style.display = "none"
            //                } else {
            //                    document.getElementById("box-chat").style.height = "400px"
            //                    document.getElementById("div-message-chat").style.display = "block"
            //                }
            //
            //
            //            },

            showIssueText(text, index ){

                this.issues[index].intro = text

            },

            onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
                this.srcPlay =  window.URL.createObjectURL(data)
                this.src =  data

            },

            headerStyles(issueType){
                if (issueType.type == 1)
                    return '2px solid #880e4e'
                else if (issueType.type == 2)
                    return '2px solid #f50057'
                else if (issueType.type == 3)
                    return '2px solid #8e24aa'
                else if (issueType.type == 4)
                    return '2px solid #263238'
                else if (issueType.type == 5)
                    return '2px solid #dd2c00'
                else if (issueType.type == 6)
                    return '2px solid #00c853'
                else if (issueType.type == 7)
                    return '2px solid #0097a7'
                else if (issueType.type == 8)
                    return '2px solid #0288d1'
                else if (issueType.type == 9)
                    return '2px solid #0208ff'
                else if (issueType.type == 10)
                    return '2px solid #eeb600'
                else if (issueType.type == 10)
                    return '2px solid #0e8e2e'
                else if (issueType.type == 11)
                    return '2px solid #888'
                else
                    return '2px solid #888888'
            },



            boardColor(boardID){
                if (boardID == 1)
                    return '#ee6600'
                else if (boardID == 2)
                    return '#ffd600'
                else if (boardID == 3)
                    return '#aeb130'
                else if (boardID == 4)
                    return '#64dd17'
                else if (boardID == 5)
                    return '#0097a7'
                else if (boardID == 6)
                    return '#00bfa5'
                else
                    return ''
            },

            typeBadgeStyles(issueType){
                if (issueType.type == 1)
                    return '#880e4e'
                else if (issueType.type == 2)
                    return '#f50057'
                else if (issueType.type == 3)
                    return '#8e24aa'
                else if (issueType.type == 4)
                    return '#263238'
                else if (issueType.type == 5)
                    return '#dd2c00'
                else if (issueType.type == 6)
                    return '#00c853'
                else if (issueType.type == 7)
                    return '#0097a7'
                else if (issueType.type == 8)
                    return '#0288d1'
                else if (issueType.type == 9)
                    return '#0208ff'
                else if (issueType.type == 10)
                    return '#eeb600'
                else if (issueType.type == 10)
                    return '#0e8e2e'
                else if (issueType.type == 11)
                    return '#888'
                else
                    return '#888888'
            },







            issueTypeText(issueType) {
                if (issueType.type == 1)
                    return 'سرنخ (Lead)'
                else if (issueType.type == 2)
                    return 'فرصت (Opportunity)'
                else if (issueType.type == 3)
                    return 'ملاقات/جلسه/رویداد'
                else if (issueType.type == 4)
                    return 'پیگیری (Ticket)'
                else if (issueType.type == 5)
                    return 'ایراد (Bug)'
                else if (issueType.type == 6)
                    return 'فعالیت (Task)'
                else if (issueType.type == 7)
                    return 'لیست/شرح (Story)'
                else if (issueType.type == 8)
                    return 'مجموعه/امکانات (Epic)'
                else if (issueType.type == 9)
                    return 'پیام/تلفن (Message)'
                else if (issueType.type == 10)
                    return 'گزارش/خبر (Report)'
                else if (issueType.type == 11)
                    return 'سایر'
                else
                    return 'سایر'
            },


            getCourseCategories(){
                var app = this;
                axios.get('/api/admin/list/5', app.auth)
                    .then(function (response) {
                        app.courseCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getFileCategories(){
                var app = this;
                axios.get('/api/file/tagSearch/', app.auth)
                    .then(function (response) {
                        app.fileCategories = response.data.data.tags.data

                        console.log(response.data.data.tags.data)


                        for (const key in app.fileCategories) {
                            if (app.fileCategories.hasOwnProperty(key)) {
                                const element = app.fileCategories[key];

                                app.options.push({
                                    title: '#'+element.title,
                                    id: element.id
                                })
                                // this.details[0].
                            }
                        }
                        console.log(app.options)


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForumCategories(){
                var app = this;
                axios.get('/api/admin/list/2', app.auth)
                    .then(function (response) {
                        app.forumCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForums(){
                var app = this;
                axios.get('/api/forum/best', app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            updateForums(event){
                var categoryID = event;
                var app = this;
                axios.get('/api/forum/list?cat_id='+categoryID, app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            likeIssue(issue){
                var app = this;
                axios.get('/api/issue/like/'+issue.id, app.auth)
                    .then(function (response) {

                        console.log(app.issues.find(x => x.id == issue.id).user_like)

                        if (app.issues.find(x => x.id == issue.id).user_like.length == 0) {
                            app.$snotify.success('پسند شما برای این پست (Issue) ثبت شد');
                            $("#like-far-"+issue.id).attr("data-prefix","fas");
                            $("#like-fas-"+issue.id).attr("data-prefix","fas");
                            // $("#like-far-"+issue.id).removeClass("fas").addClass("far");
                            app.issues.find(x => x.id == issue.id).like ++
                            app.issues.find(x => x.id == issue.id).user_like.push({
                                types_id: 1,
                                users_id: 0,
                                targets_id: issue.id})
                        }
                        else{
                            app.$snotify.info('پسند شما برای این پست (Issue) لغو شد');
                            $("#like-fas-"+issue.id).attr("data-prefix","far");
                            $("#like-far-"+issue.id).attr("data-prefix","far");
                            // $("#like-fas-"+post.id).removeClass("far").addClass("fas");
                            app.issues.find(x => x.id == issue.id).like --
                            app.issues.find(x => x.id == issue.id).user_like = []
                        }


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getUserLikes(issue){
                var app = this;
                axios.get('/api/intro/likes/'+issue.id, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issue.id).issue_likes = response.data

                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            sendComment(issueId){
                var app = this;
                var newItem = {
                    parent_id: 0,
                    issue_id: issueId,
                    comment: document.getElementById('newComment-'+issueId).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('نظر با موفقیت ثبت شد');
                        document.getElementById('newComment-'+issueId).value = ''
                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت نظر وجود ندارد');
                        }
                    );

            },

            showReplyForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).show();
            },

            sendReply(issueId, commentID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issu_id: postId,
                    comment: document.getElementById('reply-'+issueId+'-'+commentID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+commentID).hide();
                        document.getElementById('reply-'+issueId+'-'+commentID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },

            sendReplyOfReply(issueId, commentID, replyID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issue_id: issueId,
                    comment: document.getElementById('reply-'+issueId+'-'+replyID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+replyID).hide();
                        document.getElementById('reply-'+issueId+'-'+replyID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },

            hideForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).hide();
            },

            updateIssueComments(issueId){

                var app = this;
                axios.get('/api/intro/getComments/'+issueId+'/'+null, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issueId).comments = response.data.data.data

                        console.log(app.issues.find(x => x.id == issueId).comments)
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });

            },

            getMoreComments(issueId){

                var app = this;
                if (!app.issues.find(x => x.id == issueId).commentPage)
                    app.issues.find(x => x.id == issueId).commentPage =2

                axios.get('/api/intro/getComments/'+issueId+'/'+null+'?page='+app.issues.find(x => x.id == issueId).commentPage, app.auth)
                    .then(res => {
                        res.data.data.data.forEach(
                            (val)=>{ app.issues.find(x => x.id == issueId).comments.push(val)});

                        if (res.data.data.data.length != 0)
                            app.issues.find(x => x.id == issueId).commentPage = res.data.data.current_page+1


                    })
                    .catch(error => {
                        console.log(error);
                    })



            },

            customLabel(option) {
                //   console.log(option.title)

                //   this.item.tags.push(option)
                return `${option.title}`

            },

            addTag (newTag) {
                // const tag = {
                //     name: newTag,
                //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                // }
                // this.options.push(tag)
                // this.value.push(tag)

                this.options.push({
                    title: '#'+newTag,
                    id: 0
                })
            },

            ajaxFindTag(query){

            },

            limitText (count) {
                return `and ${count} other tags`
            },

            asyncFind (query) {
                this.isLoading = true
                this.ajaxFindTag(query).then(response => {
                    this.tags = response
                    this.isLoading = false
                })
            },

            clearAll () {
                this.selectedTags = []
            },

            bootstrapColor(key){
                if (key ==0)
                    return 'info'
                if (key ==1)
                    return 'danger'
                if (key ==2)
                    return 'warning'
                if (key ==3)
                    return 'success'
                if (key ==4)
                    return 'secondary'
                else
                    return 'primary'
            },

            styleColor(sprintID){
                if (sprintID == 1)
                    return '#9e9e9e'
                else if (sprintID == 2)
                    return '#9e9e9e'
                else if (sprintID == 3)
                    return '#9e9e9e'
                else if (sprintID == 4)
                    return '#9e9e9e'
                else if (sprintID == 5)
                    return '#9e9e9e'
                else if (sprintID == 6)
                    return '#9e9e9e'
                else
                    return '#9e9e9e'
            },












            createSprint(){
                var app = this;
                // if (app.newSprint.forum_category_id == null){
                //     app.$snotify.error('دسته مشخص نشده است')
                //     return false}
                //////////////////////////////////////

                if (app.newSprint.title.length == 0)
                    app.$snotify.error('ورودی های Sprint خالی است')


                if (app.newSprint.title.length > 20){
                    app.$snotify.error('تعداد حروف بیشتر از 20 کاراکتر است! متن رو کوتاه تر نمایید. ');
                }else {

                    app.newSprint.state = 1

                    var newItem = app.newSprint;

                    axios.post('/api/sprints', newItem , app.auth)
                            .then(function (resp) {
                            console.log(resp,"newSprint")
                            app.$snotify.success('Sprint با موفقیت ثبت شد');

                            app.newSprint.title = ''
                            app.newSprint.note = ''

                            // app.getSprints()
                        })
                        .catch(
                            e => {
                                console.log(e);
                                app.$snotify.error('امکان ثبت sprint وجود ندارد');
                            }
                        );

                }


            },


            editSprint(sprint){
                var app = this;

                // var params= {
                //     title: title,
                //     text: text,
                // }

                var newItem = sprint;
                axios.patch('/api/sprints/' + sprint.id, newItem, app.auth)
                    .then(function (resp) {
                        console.log(resp,"")
                        // app.items.push(app.timing);
                        app.$snotify.success('sprint با موفقیت ویرایش شد');

                    })
                    .catch(
                        e => {
                            console.log(e);
                            app.$snotify.error('امکان ثبت ویرایش وجود ندارد');
                        }
                    );

            },
            deleteSprint(id) {
                if (confirm("از حذف sprint مطمئن هستید؟")) {
                    var app = this;
                    axios.delete('/api/sprints/' + id , app.auth)
                        .then(function (resp) {
                            app.$snotify.success('حذف انجام شد');

                        })
                        .catch(function (resp) {
                            app.$snotify.danger("امکان حذف sprint وجود ندارد");
                        });
                }
            },

















        },




        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: !this.editable,
                    ghostClass: "ghost"
                };
            },
            // listString() {
            //     return JSON.stringify(this.issues, null, 2);
            // },
            // list2String() {
            //     return JSON.stringify(this.issues2, null, 2);
            // },
            // list3String() {
            //     return JSON.stringify(this.issues3, null, 2);
            // }
        },
        watch: {
            isDragging(newValue) {
                if (newValue) {
                    this.delayedDragging = true;
                    return;
                }
                this.$nextTick(() => {
                    this.delayedDragging = false;
                });

            }
        }


    }
</script>











<style>

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }



    .user-image{
        height: 30px;
        width: 30px;
        overflow: hidden;
        display:inline-block;
        text-align: right;
        float: right;
        border-radius: 100%;
        border: 2px solid #CDDC39;
        margin-left: 5px
    }


    .style-img-textarea {
        top: 18px;
        right: 25px;
    }

    @media (max-width: 767px) {

        .daynamik-bg-intro {
            padding: 0 30px;
            padding-right: 33px;
            background: #F6FAFB;

        }


    }


    .modal-content  { border: #00acc1 2px solid;
        /*-webkit-border-radius: 0px !important;*/
        /*-moz-border-radius: 0px !important;*/
        /*border-radius: 0px !important;*/
    }



</style>
